// Generated by Melange

import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptNotFound(Props) {
  let error = Props.error;
  const mightBeInQueue = error.errorInfo.reason === "200411";
  if (mightBeInQueue) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "w-30 h-30",
                        src: StaticAsset.src("/static/icons/receipt-in-queue.svg")
                      }),
                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                        className: "mt-10",
                        children: "Чек не найден"
                      }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "mt-1 text-center text-gray-medium",
                        children: "Возможно, чек все еще в очереди на обработку, обновите страницу позднее."
                      })
                ],
                className: "w-full md:w-112 bg-white mt-6 md:mt-10 rounded-md shadow-card p-10 flex flex-col items-center"
              });
  } else {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "w-30 h-30",
                        src: StaticAsset.src("/static/icons/crumpled-receipt.svg")
                      }),
                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                        className: "mt-10",
                        children: "Чек не найден"
                      }),
                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "mt-1 text-center text-gray-medium",
                        children: "Возможно, этот чек выбросили, или такого чека не было."
                      })
                ],
                className: "w-full md:w-112 bg-white mt-6 md:mt-10 rounded-md shadow-card p-10 flex flex-col items-center"
              });
  }
}

const make = ReceiptNotFound;

export {
  make ,
}
/* Buhta_components__Text Not a pure module */
